import type { AnyFormFinalSetupObject } from "../../../../widgetDataTs.js";

export function getSelectedDocuments (widgetSetup: AnyFormFinalSetupObject)
{
  type MaybeDocumentForm = Partial<Extract<typeof widgetSetup.form, { "document": any; }>>;
  return (widgetSetup?.form as MaybeDocumentForm)?.document?.selected ?? null;
}

export function getSelectedVideo (widgetSetup: AnyFormFinalSetupObject)
{
  type MaybeVideoForm = Partial<Extract<typeof widgetSetup.form, { "video": any; }>>;
  return (widgetSetup?.form as MaybeVideoForm)?.video?.selected ?? null;
}
